import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 각 센서 타입별 운영 정보를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSensorOperationInfo(params) {
    return axios.post(`${baseUrl}/performance/analysis/sensor/get-operation-info.do`, params);
  },
  getCurrentSensorOperationInfo(params) {
    return axios.post(`${baseUrl}/performance/analysis/sensor/get-current-sensor-operation-info.do`, params);
  },
  /**
   * [성능/운영>요약] 센서 구성정보 위젯 정보 조회
   * @author jeee12
   * @param  {Object} params objId
   * @return {Object}        해당 위젯에 표현될 구성정보
   */
  getSensorConfigurationInfo(params) {
    return axios.get(`${baseUrl}/performance/summary/sensor/get-configuration-info.do`, { params });
  },
  /**
   * [성능/운영>요약] 센서 성능위젯 정보 조회
   * @author jeee12
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltList(params) {
    const sensorType = params.rscInfoList ? params.rscInfoList[0].rsctypeId : params.rsctypeId;
    const widgetKey = params.summaryWidgetKey.toLowerCase();
    if (params.summaryWidgetKey === 'FFIREDS') {
      return axios.post(`${baseUrl}/performance/summary/sensor/get-${sensorType.toLowerCase()}-rsc-rslt-list.do`, params);
    }
    return axios.post(`${baseUrl}/performance/summary/sensor/get-${sensorType.toLowerCase()}-${widgetKey}-rsc-rslt-list.do`, params);
  },
  /**
   * [성능/운영>요약] 센서 성능위젯 정보 조회 (후면)
   * @author jeee12
   * @param  {Object} params objId, 조회할 rsc정보 등
   * @return {Map}        해당 위젯에 표현될 성능정보
   */
  getSummaryRscRsltBackList(params) {
    const sensorType = params.rscInfoList ? params.rscInfoList[0].rsctypeId : params.rsctypeId;
    const widgetKey = params.summaryWidgetKey.toLowerCase();
    return axios.post(`${baseUrl}/performance/summary/sensor/get-${sensorType.toLowerCase()}-${widgetKey}-rsc-rslt-back-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/sensor/sensor.js